import React, { useState } from "react";
import BlogData from "../../../data/blog.json";
import PageTitle from "../../../components/page-title";
import BlogFilter from "../../../components/blog/blog-filter";
import BlogItem from "../../../components/blog/blog-item";
import { slugify } from "../../../utils";
import "../blog.scss";

const BlogContainer = () => {
    const [activeFilter, setActiveFilter] = useState("*");

    // Extract unique categories
    const categories = [
        ...new Set(BlogData.flatMap((item) => item.categories)),
    ];

    // Filter data
    const filteredData =
        activeFilter === "*"
            ? BlogData
            : BlogData.filter((item) =>
                  item.categories.some((cat) => slugify(cat) === activeFilter)
              );

    return (
        <section className="blog-saas-section">
            <div className="container">
                <div className="section-title" data-aos="fade-up">
                    <h2>
                        Read the latest blog <span>articles</span>
                    </h2>
                </div>

                <div
                    className="filter-wrapper"
                    data-aos="fade-up"
                    data-aos-delay="100"
                >
                    <BlogFilter
                        categories={categories}
                        activeFilter={activeFilter}
                        onChange={setActiveFilter}
                    />
                </div>
            </div>

            <div className="container">
                <div className="blog-section mt-5">
                    <div className="blog-grid-modern">
                        {filteredData.map((project) => (
                            <div
                                key={project.id}
                                data-aos="fade-up"
                                data-aos-delay="200"
                            >
                                <BlogItem data={project} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BlogContainer;
